// @owners { team: patients-team }
import { COLORS } from '@alto/design-library-tokens';
import { AltoIcon, Body, Row } from '@alto/design-system';
import React from 'react';
import { getUserTagText } from '~shared/features/family-accounts/selectors/getUserTagText';
import { getHasFamily } from '~shared/features/users/selectors/getHasFamily';
import { useSelectorShared } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';

type Props = {
  readonly userIDs: (number | undefined)[];
  readonly small?: boolean;
  readonly light?: boolean;
};

export const UserTag: React.FC<Props> = ({ userIDs, small = false, light }) => {
  const hasFamily = useSelectorShared((state: ReduxStateShared) => getHasFamily(state));
  const text = useSelectorShared((state: ReduxStateShared) => getUserTagText(state, { userIDs }));

  if (!hasFamily) {
    return null;
  }

  return (
    <Row
      centerVertically
      gap="XS"
    >
      <AltoIcon
        name="user-small"
        type="grey"
      />
      <Body
        color={light ? COLORS.TEXT_COLORS.GREY : COLORS.TEXT_COLORS.BLACK}
        textSize={small ? 'mini' : undefined}
      >
        {text}
      </Body>
    </Row>
  );
};
